import { useState } from "react";
import { Modal } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import { createFormHelper } from "lib/Form";
import { CreateApiKeyModalForm } from "modules/AccessKeysDashboard/components/CreateApiKeyModal/CreateApiKeyForm";
import "modules/AccessKeysDashboard/components/CreateApiKeyModal/CreateApiKeyModal.scss";
import { useCreateAccountMutation } from "modules/AccessKeysDashboard/hooks";

export type CreateApiKeyFormPayload = {
  keyName: string;
  contact: string;
  email: string;
  phone: string;
  purpose: string;
};

type CreateApiKeyModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const FormHelper = createFormHelper<CreateApiKeyFormPayload>();

export const CreateApiKeyModal = ({ isOpen, onClose }: CreateApiKeyModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { selectedDealer } = useSelectedDealer();
  const { mutateAsync: createAccount, isPending: isCreateAccountPending } = useCreateAccountMutation();

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const validateFormData = ({ contact, email, keyName, phone, purpose }: CreateApiKeyFormPayload) => {
    const isFormInvalid = !contact || !email || !phone || !purpose || !keyName;
    setHasErrors(isFormInvalid);
    return isFormInvalid;
  };

  const handleSubmit = async (values: CreateApiKeyFormPayload) => {
    if (validateFormData(values)) return;

    await createAccount({
      name: values.keyName,
      purpose: values.purpose,
      dealer_id: selectedDealer?.id ?? -1,
      contact: `${values.contact} ${values.email} ${values.phone}`
    });
    handleClose();
  };

  return (
    <Modal open={isOpen} size="small">
      <FormHelper.Form onSubmit={handleSubmit} defaultValues={{ contact: "", email: "", keyName: "", phone: "", purpose: "" }}>
        <div className="CreateApiKeyModal">
          <CreateApiKeyModalForm hasErrors={hasErrors} onClose={handleClose} onSubmit={handleSubmit} isCreateAccountPending={isCreateAccountPending} />
        </div>
      </FormHelper.Form>
    </Modal>
  );
};
